var paragraph_default = {
  "fontElementMap": "euOII",
  "elementSpacing": "ISvF4",
  "text": "h8yAD ISvF4",
  "child": "-gksU"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
